import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Contextos
import { useAuth } from '../../contexts/AuthContext';

// Hooks
import { useIsMobile } from '../../hooks/useIsMobile';

// Estilos
import styles from './navbar.module.css';

// Assets
import logo from '../../assets/logo_sante.png';
import { GoHome } from "react-icons/go";
import { FiMenu } from "react-icons/fi";

// Constantes
import menuData from '../../constants/menuData';
import { isParticipantFlowPath } from '../../constants/participantRoutes';

// Componentes
import TokenBar from '../TokenBar/TokenBar';
import LanguageSelector from '../LanguageSelector/LanguageSelector';

function Navbar() {
  const { isAuthenticated, logout, tipoUsuario } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useIsMobile();
  const { t } = useTranslation();
  const isParticipantFlow = isParticipantFlowPath(location.pathname);

  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    if (tipoUsuario === 'admin') {
      navigate('/');
    } else {
      navigate('/participante/login');
    }
    setMenuOpen(false);
  };

  const isActive = (path) => location.pathname === path;

  const handleNavigate = (path) => {
    navigate(path);
    setMenuOpen(false);
  };

  const esconderMenuMobile = (
    location.pathname === '/' ||
    isParticipantFlow
  );

  return (
    <>
      <div className={styles.Navbar}>
        <div className={styles.logoContainer}>
          <img src={logo} alt="Logo Santé" className={styles.logo} />
        </div>

        <div className={styles.actions}>
          {isParticipantFlow && <LanguageSelector />}

          {isAuthenticated && (
            <>
            {isMobile ? (
              !esconderMenuMobile ? (
                <>
                  <button
                    className={styles.menuButton}
                    onClick={() => setMenuOpen(!menuOpen)}
                  >
                    <FiMenu />
                  </button>

                  {menuOpen && (
                    <div className={styles.mobileMenu}>
                      {/* Botão Home fixo */}
                      {isActive('/home') ? (
                        <button
                          className={`${styles.menuItem} ${styles.disabled}`}
                          disabled
                        >
                          <span className={styles.icon}><GoHome /></span>
                          Home
                        </button>
                      ) : (
                        <button
                          className={styles.menuItem}
                          onClick={() => handleNavigate('/home')}
                        >
                          <span className={styles.icon}><GoHome /></span>
                          Home
                        </button>
                      )}

                      {/* Botões dinâmicos */}
                      {menuData.map((grupo, index) =>
                        grupo.botoes.map((item, i) =>
                          isActive(item.link) ? (
                            <button
                              key={`${index}-${i}`}
                              className={`${styles.menuItem} ${styles.disabled}`}
                              disabled
                            >
                              <span className={styles.icon}><item.icone /></span>
                              {item.nome}
                            </button>
                          ) : (
                            <button
                              key={`${index}-${i}`}
                              className={styles.menuItem}
                              onClick={() => handleNavigate(item.link)}
                            >
                              <span className={styles.icon}><item.icone /></span>
                              {item.nome}
                            </button>
                          )
                        )
                      )}

                      <button
                        className={`${styles.menuItem} ${styles.logoutButton}`}
                        onClick={handleLogout}
                      >
                        {isParticipantFlow ? t('common.logout') : 'Sair'}
                      </button>
                    </div>
                  )}
                </>
              ) : (
                <button
                  className={styles.logoutLink}
                  onClick={handleLogout}
                >
                  {isParticipantFlow ? t('common.logout') : 'Sair'}
                </button>
              )
            ) : (
              <button
                className={styles.logoutLink}
                onClick={handleLogout}
              >
                {isParticipantFlow ? t('common.logout') : 'Sair'}
              </button>
            )}
            </>
          )}
        </div>
      </div>

      {isAuthenticated && <TokenBar />}
    </>
  );
}

export default Navbar;
